import React from "react";
import styles from "./Browse.module.css";
import Loading from "../Loading/Loading";
import Slider from "../Slider/Slider";
import { useStories } from "../Story/StoryHooks";

const Browse = ({ term, type }) => {
  const typeDict = {
    title: "searchTitle",
    tags: "publishedTags",
    genre: "searchGenre",
    text: "searchText",
  };
  const [stories, loading] = useStories(
    {
      sub: typeDict[type],
      type: type + " browse " + term,
      query: {
        [type]: term,
      },
    },
    true
  );

  if (loading) return <Loading />;

  return (
    <>
      <div className={styles.MainContainer}>
        <div style={{ width: "100%" }}>
          <h3>
            {type}: <b>{term}</b>
          </h3>
          {!stories || stories.length === 0 ? (
            <h3>No stories found</h3>
          ) : (
            <React.Fragment>
              {/* <h5 className={styles.sectionHeader}>{term}</h5> */}
              <Slider data={stories} />
            </React.Fragment>
          )}
        </div>
      </div>
    </>
  );
};

export default Browse;
